import { auditReports } from '@mi-front/api-clients';
import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { aodRunCompletionReasonMessages } from '../../../messages';
import { getAodRunCompletionComment } from '../../../utils/aod-run-completion-reason';
import { InfoM } from '../../aod-rule-view/components/InfoM';

interface AodRunCompletionCommentInfoProps {
  run: auditReports.AodRun;
}

/**
 * Shows the optional completion comment on its own row below status/reason/efficiency.
 */
export function AodRunCompletionCommentInfo({ run }: AodRunCompletionCommentInfoProps) {
  const { formatMessage } = useIntl();
  const comment = getAodRunCompletionComment(run);

  if (!comment) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <InfoM label={formatMessage(aodRunCompletionReasonMessages.comment)}>
        <Typography variant="body2">{comment}</Typography>
      </InfoM>
    </Grid>
  );
}
